import { Injectable } from '@angular/core';

export type AssetMode = 'ABSOLUTE' | 'RELATIVE';

export interface AssetConfig {
  mode: AssetMode;
  baseUrl?: string;
}

let _assetConfig: AssetConfig | null = null;

/** Initialize once at bootstrap */
export function initAssetResolver(config) {
  const { assetConfig = { mode: 'RELATIVE' } } = config;
  _assetConfig = assetConfig;
}

/** Resolve asset URL anywhere (TS, DOM, Angular, non-Angular) */
export function resolveAsset(path: string): string {
  if (!path) return '';

  // If not initialized yet, be safe
  if (!_assetConfig) {
    console.warn('[asset-resolver] not initialized yet');
    return path;
  }

  // Already absolute
  if (/^(https?:|data:|blob:)/.test(path)) {
    return path;
  }

  const clean = path.startsWith('/') ? path : `/${path}`;

  if (_assetConfig.mode === 'ABSOLUTE' && _assetConfig.baseUrl) {
    return `${_assetConfig.baseUrl}${clean}`;
  }

  return clean;
}

@Injectable({
  providedIn: 'root',
})
export class AssetResolverService {
  private config!: AssetConfig;

  constructor() {}

  public init(configuration): void {
    const { assetConfig = { mode: 'RELATIVE' } } = configuration;
    this.config = assetConfig;
  }

  public resolve(path: string): string {
    if (!path) return '';

    // already absolute (http, https, data, blob)
    if (/^(https?:|data:|blob:)/.test(path)) {
      return path;
    }

    const clean = path.startsWith('/') ? path : `/${path}`;

    if (this.config.mode === 'ABSOLUTE' && this.config.baseUrl) {
      return `${this.config.baseUrl}${clean}`;
    }

    return clean;
  }
}
